import { cbPalette } from "./colourBlind";
// Each law's own colour on the Legal obligations page, the way each standard has its FW_COLOR
// (nav/frameworkMeta.ts): an identity swatch, not a status, so it is the same in every theme.
// The colour follows the law's place in the organisation's list of laws, so a law keeps its
// colour however the page is filtered.

const LAW_PALETTE = cbPalette([
  "#1565c0", "#2e7d32", "#c62828", "#e65100", "#6a1b9a",
  "#00695c", "#4e342e", "#0288d1", "#558b2f", "#7b1fa2",
  "#ad1457", "#00838f", "#f57f17", "#37474f", "#283593",
] as const);

export function lawColor(law: string, allLaws: readonly string[]): string {
  const i = allLaws.indexOf(law);
  return LAW_PALETTE[(i < 0 ? 0 : i) % LAW_PALETTE.length];
}
